import sharedSiteData from '../data/site-shared.json';
import sushflixData from '../data/experiences/sushflix.json';
import diptiflixData from '../data/diptiflix.json';

export const ALBUM_BY_SLUG = {
  sushflix: sushflixData,
  diptiflix: diptiflixData,
};

export const getAlbumBySlug = (slug) => {
  const personData = ALBUM_BY_SLUG[slug];
  if (!personData) return null;
  const profile = (sharedSiteData.profiles || []).find((entry) => entry.slug === slug);

  return {
    ...personData,
    ui: {
      ...(sharedSiteData.ui || {}),
      ...(personData.ui || {}),
      profilePath: personData.ui?.profilePath || profile?.avatarPath || sharedSiteData.ui?.defaultProfilePath,
    },
    profiles: profile ? [profile] : [],
    shared: sharedSiteData,
  };
};

export const getSharedSiteData = () => sharedSiteData;
